
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44.467 9.225l5.5 5.5c.5.5.5 2.2 0 2.8l-21.2 21.2c-.05 0-.075.025-.1.05-.025.025-.05.05-.1.05s-.075.025-.1.05c-.025.025-.05.05-.1.05-2.2.3-4.4.7-6.6 1.1-.2 0-.3-.1-.4-.2-.1 0-.1-.1-.1-.1-.1-.2-.2-.5-.2-.8-.1-.4 0-1 .1-1.4.162-1.083.354-2.137.544-3.178.16-.88.318-1.751.456-2.622 0-.5.1-1 .4-1.3l21.2-21.2c.3-.3.4-.3.7 0zm-2.1 4.8l3.8 3.8c.2-.2.389-.4.578-.6.377-.4.755-.8 1.222-1.2l-3.8-3.8-1.8 1.8zm-1.6 1.8l-.2-.2c-.911.52-2.246 2.1-3.287 3.333-.56.661-1.034 1.223-1.313 1.467l-11.3 11.3 3.8 3.8 16-16-1.7-1.7c-.152-.151-.376-.349-.622-.564-.565-.496-1.239-1.087-1.378-1.436zm-15.1 20.3l-2.3-2.3c-.2.9-.4 1.9-.5 2.8.456-.091.891-.162 1.315-.23.506-.082.995-.161 1.485-.27z"}}),_c('path',{attrs:{"d":"M46.219 36.72c-.077-1.3-.152-2.58-.152-3.795 0-1.9 1.3-1.8 1.4-.1 0 .964.086 2.157.18 3.466.425 5.884 1.018 14.107-5.28 14.434-5.6.267-11.2.178-16.8.089-2.8-.045-5.6-.089-8.4-.089l-.46.001c-2.453.011-4.91.023-6.04-2.801-.674-1.722-.563-3.948-.465-5.923.033-.663.065-1.299.065-1.877 0-2.56-.067-5.14-.133-7.73-.134-5.2-.268-10.43.133-15.57.488-6.18 7.92-5.615 13.53-5.189 1.288.098 2.48.189 3.47.189 1 0 1 3.2 0 3.2-1.26 0-2.541-.044-3.83-.088-2.6-.09-5.23-.18-7.77.088-4.175.435-4.114 2.61-4.027 5.67.013.457.027.935.027 1.43v15c0 .644-.057 1.391-.118 2.185-.25 3.274-.563 7.35 2.818 8.315 1.696.475 3.9.305 5.953.147.972-.075 1.911-.147 2.747-.147h15c.492 0 1.003.021 1.519.043 2.836.118 5.804.242 6.48-3.143.47-2.417.31-5.15.153-7.806z"}})])
          )
        }
      }
    